const prepareServerValidationError = (errors) => {
    const validationError = {};

    errors.forEach((error) => {
        validationError[error.field] = error.message;
    });

    return validationError;
};

export default prepareServerValidationError;
